import Integer from './integer';
import String from './string';

export default {
    Integer,
    String
};



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/shop-builder/core/prop-types/index.ts